/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCondition } from './get-onboarding-request-by-id200-response-antisocial-forces-check-inner-condition';
// May contain unused imports in some cases
// @ts-ignore
import { GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner } from './get-onboarding-request-by-id200-response-antisocial-forces-check-inner-results-inner';

/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
 */
export interface GetOnboardingRequestById200ResponseAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'category'?: GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCategoryEnum;
    /**
     * 
     * @type {GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCondition}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'condition'?: GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCondition;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'payloadDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'payloadId'?: string;
    /**
     * 
     * @type {Array<GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner>}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'results'?: Array<GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'status'?: GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerStatusEnum;
}

export const GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCategoryEnum = {
    company: 'company',
    customer: 'customer'
} as const;

export type GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCategoryEnum = typeof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCategoryEnum[keyof typeof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCategoryEnum];
export const GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerStatusEnum = {
    done: 'DONE',
    requested: 'REQUESTED',
    manualApproval: 'MANUAL_APPROVAL'
} as const;

export type GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerStatusEnum = typeof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerStatusEnum[keyof typeof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerStatusEnum];


